import { Layout, Result404 } from 'components';
import { ResultError } from 'components/errors';
import { MainFiltersProvider } from 'components/main-filters/main-filters.context';
import { sideBarpermission } from 'components/side-bar/side-bar-permission';
import { AccountSettingsView } from 'features/account-settings';
import { LoginView } from 'features/auth';
import { CurrencyView } from 'features/cms';
import { EventDetailsView, EventsView } from 'features/events';
import DetailPage from 'features/transaction_list/modal/participante-edit';
import { InvoiceDetailsView } from 'features/transaction_list/routes/invoice-list-view';
import { ParticipateListView } from 'features/transaction_list/routes/paritipate-list';
import { ReportsListView } from 'features/transaction_list/routes/reports';
import { UploadListView } from 'features/transaction_list/routes/upload-list';
import {
  AdminDetailView,
} from 'features/users';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { AuthenticatedRoute } from './authenticated-route';
import { ROUTES } from './constants';
import { UnauthenticatedRoute } from './unauthenticated-route';
import { ExecutiveSummary } from 'features/dashboard/routes/executive-summary';
import { RegistrationCross } from 'features/dashboard/routes/registration-cross';
import { ShopCrossView } from 'features/dashboard/routes/shop-cross-view';
import { BoothSales } from 'features/dashboard/routes/Booth-sales';
import { BoothsTargetView } from 'features/dashboard/routes/Booth-target-view';
import { RegistrationAnalysisstepPerMonthView } from 'features/dashboard/routes/RegistrationAnalysisstepPerMonth-View';
import { DemographicregistrationView } from 'features/dashboard/routes/Demographic';
import { RegistrationCrossSalesView } from 'features/dashboard/routes/registration-cross-sales';
import { HomePageView } from 'features/dashboard/routes/HomePage';
import { InvoiceListView } from 'features/transaction_list/routes/invoice-list';
import { RestrictedNewRoute } from './newrestricted-route';
import LayoutView from 'features/dashboard/routes/layoutView';
import UploadListDetails from 'features/transaction_list/routes/upload-list-details';

export const routerConfig: RouteObject[] = [
  {
    errorElement: <ResultError />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: (
          <UnauthenticatedRoute>
            <LoginView />
          </UnauthenticatedRoute>
        ),
      },
      {
        path: ROUTES.HOME,
        element: (
          <AuthenticatedRoute>
            <Layout />
          </AuthenticatedRoute>
        ),
        children: [
          {
            path: ROUTES.HOME,
            element: (<Navigate to={ROUTES.DASHBOARD} replace />),
          },
          {
            path: ROUTES.ACCOUNT_SETTINGS,
            element: <AccountSettingsView />,
          },
          {
            path: ROUTES.USERS,
            element: <Navigate to={ROUTES.USERS_APP} replace />,
          },
          {
            path: ROUTES.DASHBOARD,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.dashboard}
                required="view"
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MainFiltersProvider>
                  {/* <DashboardView /> */}
                  <HomePageView />
                </MainFiltersProvider>
              </RestrictedNewRoute>
            ),

          },
          {
            path: ROUTES.EXECUTIVE_SUMMARY,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.executive_summary}
                required="view"
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <ExecutiveSummary />
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.REGISTRATION_CROSS_SALES,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.registration}
                required="view"
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <RegistrationCross />
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.REGISTRATION_ANALYSIS_B,
            element: (
              <RegistrationAnalysisstepPerMonthView />
            ),
          },
          {
            path: ROUTES.REGISTRATION_ANALYSIS_DEMOGRAPHI,
            element: (
              <DemographicregistrationView />
            ),
          }, {
            path: ROUTES.REGISTRATIONS_CROSS_SALES,
            element: (
              <RegistrationCrossSalesView />
            ),
          },
          {
            path: ROUTES.SHOP_CROSS,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.shop}
                required="view"
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <ShopCrossView />
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.BOOTH_SALES,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.shop}
                required="view"
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <BoothSales />
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.BOOTH,
            element: (
              <BoothsTargetView />
            ),
          },
          // {
          //   path: ROUTES.USERS_ADMIN,
          //   element: (
          //     // <RestrictedRoute
          //     //   redirectPath={ROUTES.HOME}
          //     //   requiredPermission='adminUsers.view'
          //     // >
          //     <AdminUsersView />
          //     // </RestrictedRoute>
          //   ),
          //   children: [
          //     {
          //       path: ROUTES.USERS_ADMIN_EDIT,
          //       element: (
          //         // <RestrictedRoute
          //         //   redirectPath={ROUTES.HOME}
          //         //   requiredPermission='adminUsers.edit'
          //         // >
          //         <AdminUserUpdateView />
          //         // </RestrictedRoute>
          //       ),
          //     },
          //   ],
          // },

          {
            path: ROUTES.TRANSACTION_INVOICE_LIST,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.invoice_list}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <InvoiceListView />
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.USERS_ADMIN_DETAIL,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='adminUsers.view'
              // >
              <AdminDetailView />
              // </RestrictedRoute>
            )
          },
          {
            path: ROUTES.EVENTS,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.event_list}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <EventsView />
              </RestrictedNewRoute>
            ),
          },

          // {
          //   path: ROUTES.COUPON_ITEM,
          //   element: (

          //     <CouponListView />
          //   ),
          // },

          {
            path: ROUTES.EVENTS_DETAILS,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='fields.view'
              // >
              <EventDetailsView />
              // </RestrictedRoute>
            ),
          },

          {
            path: ROUTES.CMS_CURRENCY,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='fields.view'
              // >
              <MainFiltersProvider>
                <CurrencyView />
              </MainFiltersProvider>
              // </RestrictedRoute>
            ),
          },
          // {
          //   path: ROUTES.SHOP_ITEM_SIZE,
          //   element: (
          //     // <RestrictedRoute
          //     //   redirectPath={ROUTES.HOME}
          //     //   requiredPermission='fields.view'
          //     // >
          //     <MainFiltersProvider>
          //       <SizeManagementView />
          //     </MainFiltersProvider>
          //     // </RestrictedRoute>
          //   ),
          // },
          {
            path: ROUTES.TRANSACTION__PARTICIPATE_LIST,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.participant_list}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MainFiltersProvider>
                  <ParticipateListView />
                </MainFiltersProvider>
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.TRANSACTION_INVOICE_LIST_EDIT,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='users.view'
              // >
              <InvoiceDetailsView />
              // </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.TRANSACTION__BULK_UPLOAD_LIST,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='fields.view'
              // >
              <MainFiltersProvider>
                <UploadListView />
              </MainFiltersProvider>
              // </RestrictedRoute>

            ),
          },
          {
            path: ROUTES.TRANSACTION__BULK_UPLOAD_LIST_DETAILS,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='fields.view'
              // >
              <MainFiltersProvider>
                <UploadListDetails />
              </MainFiltersProvider>
              // </RestrictedRoute>

            ),
          },
          {
            path: ROUTES.TRANSACTION__GROUP_REGISTRATION_LIST_DETAILS,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='fields.view'
              // >
              <MainFiltersProvider>
                <UploadListDetails />
              </MainFiltersProvider>
              // </RestrictedRoute>

            ),
          },
          {
            path: ROUTES.TRANSACTION__GROUP_REGISTRATION_LIST,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.group_registration}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MainFiltersProvider>
                  <UploadListView />
                </MainFiltersProvider>
              </RestrictedNewRoute>

            ),
          },
          {
            path: ROUTES.TRANSACTION__REPORTS,
            element: (
              <RestrictedNewRoute
                pageKey={sideBarpermission.reports}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MainFiltersProvider>
                  <ReportsListView />
                </MainFiltersProvider>
              </RestrictedNewRoute>
            ),
          },
          {
            path: ROUTES.TRANSACTION_PARTICIPATE_DETAIL,
            element: (
              // <RestrictedRoute
              //   redirectPath={ROUTES.HOME}
              //   requiredPermission='users.view'
              // >
              <DetailPage />
              // </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LAYOUTVIEW,
            element: (

              <LayoutView />

            ),
          },
        ],
      },

      {
        path: ROUTES.NOT_FOUND,
        element: <Result404 />,
      },
    ],
  },
];

export const router = createBrowserRouter(routerConfig);
